import { defineStyle } from "@chakra-ui/react";
import { useThemeColors } from "./useThemeColors";

export const useStyles = () => {
  const colors = useThemeColors();

  const noBarScrollBar = {
    "&::-webkit-scrollbar": {
      width: "0px",
      height: "0px",
      display: "none",
      transition: "width 0.3s ease",
    },

    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&:hover::-webkit-scrollbar-track": {
      background: colors.utility.scrollBg,
      borderRadius: "4px",
      boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "transparent",
      borderRadius: "4px",
      transition: "background-color 0.3s ease, height 0.3s ease",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: colors.utility.scroll,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: colors.utility.scroll,
    },
  };

  const scrollBar = {
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "0px",
      transition: "width 0.3s ease",
    },
    "&:hover::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&:hover::-webkit-scrollbar-track": {
      background: colors.utility.scrollBg,
      borderRadius: "4px",
      boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "transparent",
      borderRadius: "4px",
      transition: "background-color 0.3s ease, height 0.3s ease",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: colors.utility.scroll,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: colors.utility.scroll,
    },
  };

  const floatingLabelStyles = defineStyle({
    pos: "absolute",
    bg: "bg",
    px: "0.5",
    top: "-3",
    insetStart: "2",
    fontWeight: "normal",
    pointerEvents: "none",
    transition: "position",
    _peerPlaceholderShown: {
      color: "fg.muted",
      top: "2.5",
      insetStart: "3",
    },
    _peerFocusVisible: {
      color: "fg",
      top: "-3",
      insetStart: "2",
    },
  });

  return { scrollBar, noBarScrollBar, floatingLabelStyles };
};
